import { useNavigate } from "react-router-dom";
import useUser from "./useUser";
import { useEffect } from "react";

export const useRedirectUnauthorized = (disallowedRoleKey, redirectToPath) => {
  const { roles } = useUser();
  const navigate = useNavigate();
  const lowercaseRoleKey = String(disallowedRoleKey).toLowerCase();

  const isDisallowedRole = roles[lowercaseRoleKey]; 

  useEffect(() => {
    // We only perform the redirect if the specific disallowed role is true
    if (isDisallowedRole) {
      navigate(redirectToPath);
    }
  }, [navigate, isDisallowedRole, redirectToPath]);
};